import { render, staticRenderFns } from "./video-sort.vue?vue&type=template&id=50e3526b&"
import script from "./video-sort.vue?vue&type=script&lang=js&"
export * from "./video-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports